import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { T4coreModule, AuthGuard, SystemRights } from 't4core';
import { T4CommonModule } from '../../t4common/t4common';
import { ServiceModule } from '../Service/service.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DashboardComponent } from './views/dashboard/dashboard';
import { ExecutiveSummaryComponent } from './views/executiveSummary/executiveSummary'
import { SettlementReportComponent } from './views/settlementReport/settlementReport';
import { RevenueChartWidget } from './widgets/revenueChart/revenueChart';
import { RentCountChartWidget } from './widgets/rentCountChart/rentCountChart';
import { AverageIncomeChartWidget } from './widgets/averageIncomeChart/averageIncomeChart';
import { U4FPercentageChartWidget } from './widgets/percentFreeInsuranceAndPreBookingChart/percentFreeInsuranceAndPreBookingChart';
import { SettlementSummaryComponent } from './views/settlementSummary/settlementSummary';

@NgModule({
    declarations: [
    DashboardComponent,
    SettlementReportComponent,
    ExecutiveSummaryComponent,
    RevenueChartWidget,
    RentCountChartWidget,
    AverageIncomeChartWidget,
    U4FPercentageChartWidget,
    SettlementSummaryComponent
    ],
    imports: [
      T4CommonModule,
      T4coreModule,
      ServiceModule,
      DragDropModule,
        RouterModule.forChild([
            {
            path: 'Use4Free',
            canActivate: [AuthGuard],
                data: {
                  index: 11, title: "Use4Free", toolTip: "Use4Free", roles: ['GroupManager','BusinessManager'], brands: ['Use4Free'], icon: 'local_shipping'
                },
                children: [
                    { path: '', redirectTo: 'Dashboard', pathMatch: 'full' },
                    {
                      path: "Dashboard",
                      canActivate: [AuthGuard],
                      component: DashboardComponent,
                      data: { title: "Dashboard", icon: 'home', roles: ['GroupManager', 'BusinessManager'], brands: ['Use4Free'] }
                  },
                  {
                    path: "Reports",
                    data: { title: "Reports", icon: 'home', roles: ['GroupManager', 'BusinessManager'], brands: ['Use4Free'] },
                     children: [
                       { path: '', redirectTo: 'ExecutiveSummary', pathMatch: 'full' },
                      {
                        path: "ExecutiveSummary",
                        canActivate: [AuthGuard],
                        component: ExecutiveSummaryComponent,
                        data: { title: "Executive Summary", icon: 'home', roles: ['GroupManager', 'BusinessManager'], brands: ['Use4Free'] }
                      },
                      {
                        path: "SettlementSummary",
                        canActivate: [AuthGuard],
                        component: SettlementSummaryComponent,
                        data: { title: "Settlement summary", icon: 'account balance', roles: ['GroupManager', 'BusinessManager'], brands: ['Use4Free'] }
                      },
                    ]
                  },
                ]
            },
           
            
        ])
    ],
    providers: [T4CommonModule],
})
export class Use4FreeModule {
    public static theme: string = "unicorn-dark-theme";
}
